package pl.finn.forms.fk02

import io.kvision.form.FormControl
import io.kvision.form.check.CheckBox
import io.kvision.form.check.RadioGroup
import io.kvision.form.text.Text
import io.kvision.form.time.DateTime
import io.kvision.html.Button
import io.kvision.panel.FieldsetPanel

//klasa do walidacji pól dodawanych i usuwanych dynamicznie w trakcie używania formularza
class DynamicFieldsValidator { //todo move to common

  var fieldsMap = mutableMapOf<Int, FormControl>()
//  var validationFunctionsWithErrorMessagesMap: Map<String, FormControl.() -> String> = emptyMap() // mapa na kiedyś by 1 pole moglo dawac rozne bledy
  var validationFunctionsMap = mutableMapOf<Int, (String?) -> Boolean>()
//  var errorMessagesMap = mutableMapOf<Int, String>()
  var errorMessagesMap = mutableMapOf<Int, (String?) -> String>()

  var validationGroupsMap = mutableMapOf<Int, String?>()
  val nonValidationGroupsList = mutableListOf<String>()

//  fun add(element: FormControl, validationFunction: FormControl.() -> String?){
//
//  }

  fun add(element: FormControl, validationFunction: (String?) -> Boolean, errorMessage: String, validationGroup: String? = null): FormControl{
    fieldsMap.put(element.hashCode(), element)
    validationFunctionsMap.put(element.hashCode(), validationFunction)
    errorMessagesMap.put(element.hashCode(), {elem -> errorMessage})
    validationGroupsMap.put(element.hashCode(), validationGroup)
    return element
  }

  fun add(element: FormControl, validationFunction: (String?) -> Boolean, errorMessageFunction: (String?) -> String, validationGroup: String? = null): FormControl{
    fieldsMap.put(element.hashCode(), element)
    validationFunctionsMap.put(element.hashCode(), validationFunction)
    errorMessagesMap.put(element.hashCode(), errorMessageFunction)
    validationGroupsMap.put(element.hashCode(), validationGroup)
    return element
  }

  fun remove(element: FormControl) {
    fieldsMap.remove(element.hashCode())
    validationFunctionsMap.remove(element.hashCode())
    errorMessagesMap.remove(element.hashCode())
    validationGroupsMap.remove(element.hashCode())
  }

  fun removeAll(componentList: List<FormControl>) {
    componentList.forEach {
      if (it is FieldsetPanel) {
        removeAll(it.getChildren() as List<FormControl>)
      } else {
        if (it is Button) {
          //no action
        } else {
          remove(it)
        }
      }
    }
  }

  fun validate(element: FormControl): Boolean {
    if (validationFunctionsMap.get(element.hashCode()) == null || errorMessagesMap.get(element.hashCode()) == null) {
      throw Exception("Validation error")
    }
    if (notForValidation(element.hashCode())) {
      element.validatorError = null
      return true
    }
    if (!element.visible || element.parent?.visible != true || element.getElement() == null) { // sprawdzanie czy element widoczny
      element.validatorError = null
      return true
    }
    when (element){
      is DateTime -> { // for dateTime only not null check and visibility
        return if(element.getValue() != null || !element.visible || element.parent?.visible != true) {
          element.validatorError = null
          true
        } else {
          element.validatorError = (errorMessagesMap.get(element.hashCode())!!)(element.getValue() as String?)
          false
        } //todo ezw check if work correct for fk02
      }
      is RadioGroup -> {
        return if((validationFunctionsMap.get(element.hashCode())!!)(element.getValue())){
          element.validatorError = null
          true
        } else {
          element.validatorError = (errorMessagesMap.get(element.hashCode())!!)(element.getValue())
          false
        }
      }
      is CheckBox -> {
        return if((validationFunctionsMap.get(element.hashCode())!!)(element.getValue().toString())){
          element.validatorError = null
          true
        } else {
          element.validatorError = (errorMessagesMap.get(element.hashCode())!!)(element.getValue().toString())
          false
        }
      }
    }

    return if((validationFunctionsMap.get(element.hashCode())!!)(element.getValue() as String?)){
      element.validatorError = null
      true
    } else {
      element.validatorError = (errorMessagesMap.get(element.hashCode())!!)(element.getValue() as String?)
      false
    }
  }

  fun validate(): Boolean {
    var result = true
    fieldsMap.values.forEach {
      if (!validate(it)) {
        result = false
      }
    }
    return result
  }

  private fun notForValidation(elementHashCode: Int): Boolean {
    for (group in nonValidationGroupsList) {
      if(validationGroupsMap.get(elementHashCode).equals(group)){
        return true
      }
    }
    return false
  }

  fun addNotValidationGroup(group: String) {
    nonValidationGroupsList.add(group)
  }

  fun removeNotValidationGroup(groupToRemove: String) {
    for (group in nonValidationGroupsList) {
      if(groupToRemove.equals(group)){
        nonValidationGroupsList.remove(group)
      }
    }
  }

}